import { types } from 'node-sass';
<template>
  <!-- <ul class="cp-foot-table __flex __flex-vc">
    <li v-for="(item, index) in list" :key="index" @click="goPage(item, index)">
      <img :src="activeIns === index? item.activeIcon: item.icon " alt="">
      <p :class="[activeIns === index? 'active': '']">{{item.appTitle}}</p>
    </li>
  </ul> -->
  <div class="foot-contain">
    <ul class="table-list">
      <li v-for="(item, index) in list" :key="index" @click="goPage(item, index)">
        <img :src="activeIns === index? item.activeIcon: item.icon " alt="">
        <p :class="[activeIns === index? 'active': '']">{{item.appTitle}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CpFootTable',
  data () {
    return {
      activeIns: -1,
      list: [
        // {
        //   appTitle: '首页',
        //   router: '/home',
        //   icon: require('@/assets/images/table/tab_1_sy_nor.png'),
        //   activeIcon: require('@/assets/images/table/tab_1_sy_sel.png')
        // },
        // {
        //   appTitle: '事记',
        //   router: '/story',
        //   icon: require('@/assets/images/table/tab_2_sj_nor.png'),
        //   activeIcon: require('@/assets/images/table/tab_2_sj_sel.png')
        // },
        // {
        //   appTitle: '课程',
        //   router: '/course',
        //   icon: require('@/assets/images/table/tab_3_kc_nor.png'),
        //   activeIcon: require('@/assets/images/table/tab_3_kc_sel.png')
        // },
        // {
        //   appTitle: '资讯',
        //   router: '/news',
        //   icon: require('@/assets/images/table/tab_4_zx_nor.png'),
        //   activeIcon: require('@/assets/images/table/tab_4_zx_sel.png')
        // },
        // {
        //   appTitle: '党建',
        //   router: '/building',
        //   icon: require('@/assets/images/table/tab_5_dj_nor.png'),
        //   activeIcon: require('@/assets/images/table/tab_5_dj_sel.png')
        // }
      ]
    }
  },
  created () {
    const tabsList = this.$store.state.tabsList
    if (tabsList.length) {
      this.list = tabsList
      console.log('tabsList', this.list)
    } else {
      this.$store.dispatch('GetTabList').then((res) => {
        this.list = res.data
      })
    }
  },
  activated () {
    const routeIndex = this.list.findIndex(item => { return item.router === this.$route.path })
    if (routeIndex !== -1) {
      this.activeIns = routeIndex
    }
  },
  methods: {
    goPage (item, index) {
      if (index === this.activeIns) {
        return
      }
      this.$router.push({ path: item.router })
    }
  }
}
</script>

<style lang="scss" scoped>
.foot-contain{
  z-index: 10;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: space-around;
  height: 49px;
  background-color: #fff;
  box-shadow: 0px -3px 18px 0px rgba(51, 51, 51, 0.25);
  .table-list{
    display: flex;
    overflow-x: scroll;
    li {
      text-align: center;
      padding: 6px 0 5px 0;
      p {
        opacity: 1;
        font-size: 10px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        color: #828282;
        width: 75px;
        &.active {
          color: #E50914;
        }
      }
      img {
        width: 24px;
        height: 24px;
        display: block;
        margin: 0 auto;
      }
    }

  }
}
.cp-foot-table {
  z-index: 10;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: space-around;
  height: 49px;
  background-color: #fff;
  box-shadow: 0px -3px 18px 0px rgba(51, 51, 51, 0.25);
  li {
    text-align: center;
    p {
      &.active {
        color: #E50914;
      }
    }
    img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
